export default __webpack_public_path__ + "86bc2a5a8350170447c9ab13f76f8be0.otf";